export default __webpack_public_path__ + "static/media/right_trees.5acdbf91.svg";